import api from './api'

export const integrationBasePath = '/api/v1/integration'

export async function verifyIntegrationUrl(signedUrl) {
  const resp = await api.post(`${integrationBasePath}/verify-url`, { signedUrl })
  return resp.data
}

export async function readFromRedis(key) {
  const resp = await api.get(`${integrationBasePath}/read-signature?signature=${key}`)
  return resp.data
}

export async function idLogin(userIdentifier) {
  const resp = await api.post(`${integrationBasePath}/integration-id-login`, { userIdentifier })
  return resp.data
}
